import { render } from "./ProfileOrderModal.vue?vue&type=template&id=43372720"
import script from "./ProfileOrderModal.vue?vue&type=script&lang=js"
export * from "./ProfileOrderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/frontend/js/components/ProfileOrderModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43372720"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43372720', __exports__)) {
    api.reload('43372720', __exports__)
  }
  
  module.hot.accept("./ProfileOrderModal.vue?vue&type=template&id=43372720", () => {
    api.rerender('43372720', render)
  })

}


export default __exports__